export default "__VITE_ASSET__ByBf3sGf__"